module.exports = "/assets/cef97249d1bf0fda5e806b9d2babf93d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/FZ.png
// module id = 2513
// module chunks = 0